module.exports={PASSPORT:"Pasaporte",NATIONAL_ID_CARD:"Documento de identidad nacional"};